import React, { useContext, useEffect,useState } from "react";
import { Container, Row, Col, Input, CustomInput } from "reactstrap";
import { Dispatch } from "../../store/store";
import { onChangeHeader, onChange } from "../../IO";
import { LocalINTL, SimpleSuggest } from "../../Fields";
import { Field, Numeric, Combobox } from "../../../Order/Field/Field";
import { CurrencyAsset, IOTransferType } from "../../../../IO/types";
import { commissionSuffix } from "../../../Order/Form/commons";
import Account from "../../Fields/Account";
import Files from "../../Fields/Files/Files";
import Bulk from "../Bulk/Bulk";
import { updateAccountBanks, isEmpty } from "../Default";
import { processes } from "../../../../../utils/Helper";

const WithdrawalBulk = ({opsViewAccountName, disableACSelector}) => {
  const { dispatch, services, state } = useContext(Dispatch);
  const { io, fields, entities, permissions } = state;
  const { errors, readonly } = fields;
  const { allowValues, allowCash } = permissions;
  const header = io.itemsHeader;
  const simpleItem = io.items;
  const [reasons, setReasons] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);

  useEffect(()=>{
    if (disableACSelector == undefined)
      disableACSelector = false
  }, []);

  
  useEffect(() => {
    //get reasons
    try {
      services.fetchGetReasons({ process: processes.WITHDRAW }).then((r) => {
        r ? setReasons(r.keyValues) : "";
      });
    } catch (e) {
      setReasons([]);
    }
  }, []);

  useEffect(()=>{
    try {
      services.GetDocumentTypes().then((res)=>{
        const result = res.documenttypes.map((item) => ({
          id: item.DocumentTypeId,
          description: item.DocumentTypeName,
        }));
        setDocumentTypes(result)
      })
    } catch(e) {
      setDocumentTypes([]);
    }
  },[])

  useEffect(() => {
    if (header.IsCurrency && !header.BankAccountIsThirdParty) {
      if (!isEmpty(header.AccountId)) {
        if (state.io.Status === "Filled") {
          dispatch({
            type: "UPDATE_ACCOUNT_BANKS",
            accountBanks: [
              {
                BankAccountHolders: header.BankAccountHolders,
                BankAccountId: header.BankAccountId,
                BankAccountItemId: header.BankAccountItemId,
                BankAccountName: header.BankAccountName,
                BankAccountNumber: header.BankAccountNumber,
              },
            ],
          });
        } else {
          services
            .fetchGetAccountBanks({
              accountId: header.AccountId,
              currencyId: 0,
            })
            .then((r) => r.response)
            .then((r) => {
              dispatch({
                type: "UPDATE_ACCOUNT_BANKS",
                accountBanks: r.accountBanks,
              });
              if (header.BankAccountItemId === null && r.accountBanks) {
                const item = r.accountBanks[0];
                onChangeHeader(dispatch, {
                  ...item,
                });
              } else {
                const item = r.accountBanks.find((a) => a.BankAccountItemId === header.BankAccountItemId);
                onChangeHeader(dispatch, {
                  ...item,
                });
              }
            });
        }
      } else {
        dispatch({ type: "UPDATE_ACCOUNT_BANKS", accountBanks: [] });
        onChangeHeader(dispatch, {
          BankAccountItemId: null,
          BankAccountName: null,
        });
      }
    }
  }, [header.AccountId]);

  const checkSettlementDate = (tradedate, AssetId) => {
    let settlementvalue = 1;
    let inchange = false;
    onChange(dispatch, { Date: tradedate });

    if (header.IsCurrency === false) {
      if (inchange) {
        // AssetId = values.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      } else {
        //AssetId = simpleItem.AssetId;
        services.GetAssetSettlement({ AssetId }).then((r) => {
          executeSettlement(AssetId, r.DefaultSettlement, tradedate);
        });
      }
    } else {
      settlementvalue = 1;
      AssetId = 0;
      executeSettlement(AssetId, settlementvalue, tradedate);
    }
  };

  const executeSettlement = (Asset, settlementvalue, tradedate) => {
    const getdata = {
      tradedate: tradedate,
      assetId: Asset,
      ist0: false,
      settlement: settlementvalue,
    };
    services
      .GetIOSettlementDate(getdata)
      .then((r) => onChange(dispatch, { SettlementDate: r.settlementday }));
  };

  // XOR operator
  const readOnlyTypeSelector = allowValues ? !allowCash : allowCash;
  const accountEmpty = header.AccountId == null || header.AccountId == 0;

  return (
    <Container>
      <Row>
        {/* Left */}
        <Col xs={12} lg={6}>
          <Row className="mb-2" style={{ marginTop: "15px" }}>
            <Col lg={6} xs={12}>
              <LocalINTL
                isLocal={io.Local}
                readonly={readonly.Local}
                onChange={(v) => onChange(dispatch, v)}
              />
            </Col>
            <Col lg={6} xs={12}>
              <Combobox
                darken
                disabled={readonly.header_IsCurrency || readOnlyTypeSelector || disableACSelector}
                onChange={(v) =>
                  onChangeHeader(dispatch, {
                    IsCurrency: v == CurrencyAsset.Cash,
                  })
                }
                value={header.IsCurrency ? CurrencyAsset.Cash : CurrencyAsset.Asset}
                items={Object.values(CurrencyAsset).map((key, index) => ({
                  id: key,
                  description: key,
                }))}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col lg={6} xs={12}>
          {/* Date */}
          <Field label={"Date"} error={errors.Date}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Date"}
              disabled={readonly.Date}
              value={io.Date}
              invalid={!!errors.Date}
              onChange={(e) => checkSettlementDate(e.target.value, 0)}
            />
          </Field>

          {/* Settlement Date */}
          <Field label={"Settlement Date"} error={errors.SettlementDate}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Settlement Date"}
              disabled={readonly.SettlementDate}
              value={io.SettlementDate}
              invalid={!!errors.SettlementDate}
              onChange={(e) => onChange(dispatch, { SettlementDate: e.target.value })}
            />
          </Field>
        </Col>
        {/* Right */}
        <Col xs={12} lg={6}>
          {/* ##### Account ###### */}
          <Account
            AccountId={header.AccountId}
            AccountName={header.AccountName}
            AccountNumber={header.AccountNumber}
            HolderId={header.HolderId}
            HolderName={header.HolderName}
            onChange={(values) => onChangeHeader(dispatch, values)}
            readonly={{
              AccountNumber:readonly.header_AccountNumber,
              AccountName: readonly.header_AccountName,
              HolderName: readonly.header_HolderName,
            }}
            errors={{
              AccountNumber: errors.header_AccountNumber,
              AccountName: errors.header_AccountName,
              HolderName: errors.header_HolderName,
            }}
            services={{
              fetchAccountHolders: services.fetchAccountHolders,
              fetchSearchAccount: services.fetchSearchAccount,
            }}
            opsViewAccountName={opsViewAccountName}
          />
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Bulk />
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={6}>
          {header.IsCurrency && io.Local && (
            <React.Fragment>
              <Field label={"Type"} error={errors.header_TransferType}>
                <Combobox
                  value={header.TransferType}
                  items={[
                    { id: "Transfer", description: "Transfer" },
                    { id: "Cash", description: "Cash" },
                    { id: "Cheque", description: "Cheque" },
                  ]}
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_TransferType}
                  onChange={(v) => onChangeHeader(dispatch, { TransferType: v })}
                  emptyLabel={"Type"}
                />
              </Field>

              {/* ##### Bank Account ##### */}
              {header.TransferType === IOTransferType.Transfer && (
                <React.Fragment>
                  <div className="mt-2 mb-2">
                    <CustomInput
                      label="Third party bank account"
                      type="checkbox"
                      id={`cbox-thirdParty`}
                      checked={header.BankAccountIsThirdParty || false}
                      disabled={readonly.header_BankAccountIsThirdParty}
                      onChange={(v) =>
                        onChangeHeader(dispatch, {
                          BankAccountIsThirdParty: !header.BankAccountIsThirdParty,
                          ThirdPartyDocumentTypeId: documentTypes[0].id, 
                          ThirdPartyDocumentType: documentTypes[0].description,
                        })
                      }
                    />
                  </div>
                  {header.BankAccountIsThirdParty ? (
                    <React.Fragment>
                      <Row style={{ width: '100%' }}>
                        <Col lg={6}>
                      <SimpleSuggest
                        label={"Third party bank"}
                        service={services.fetchSearchCustodianEntity}
                        error={errors.header_BankAccountName}
                        disabled={readonly.simple_Quantity}
                        value={header.BankAccountName || ""}
                        onChange={({ id, name }) =>
                          onChangeHeader(dispatch, {
                            BankAccountId: id,
                            BankAccountName: name,
                          })
                        }
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                      />

                      <Field label={"Third party bank account"} error={errors.header_BankAccountNumber} style={{ whiteSpace: 'nowrap', width: '100%' }}>
                        <Input
                          type={"text"}
                          placeholder={"Account"}
                          value={header.BankAccountNumber || ""}
                          invalid={errors.header_BankAccountNumber}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              BankAccountNumber: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                          style={{ whiteSpace: 'nowrap', width: '100%' }}
                        />
                      </Field>
                          
                      <Field label={"Third party person name"} error={errors.header_ThirdPartyPersonName} style={{ whiteSpace: 'nowrap', width: '100%' }}>
                        <Input
                          type={"text"}
                          placeholder={"Person Name"}
                          value={header.ThirdPartyPersonName || ""}
                          invalid={errors.header_ThirdPartyPersonName}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              ThirdPartyPersonName: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                          style={{ whiteSpace: 'nowrap', width: '100%' }}
                        />
                      </Field>
                      </Col>
                      <Col lg={6} >
                      <Field
                        label={"Third party document type"}
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                        error={errors.header_ThirdPartyDocumentType}
                      >
                        <Combobox
                          value={(header.ThirdPartyDocumentTypeId) || ""}
                          items={documentTypes}
                          disabled={readonly.header_Quantity}
                          invalid={!!errors.header_ThirdPartyDocumentType}
                          onChange={(v) => {
                            const name = documentTypes.find(item => item.id === v);
                            onChangeHeader(dispatch, { ThirdPartyDocumentTypeId: v, ThirdPartyDocumentType: name.description})}}
                          emptyLabel={"Document Type"}
                          style={{ whiteSpace: 'nowrap', width: '100%' }}
                        />
                      </Field>
                      <Field
                        label={"Third party address or identification number"}
                        error={errors.header_ThirdPartyIdentificationNumber}
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                      >
                        <Input
                          type={"text"}
                          placeholder={"Third party address or identification number"}
                          value={header.ThirdPartyIdentificationNumber || ""}
                          invalid={errors.header_ThirdPartyIdentificationNumber}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              ThirdPartyIdentificationNumber: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                          style={{ whiteSpace: 'nowrap', width: '100%' }}
                        />
                      </Field>

                      <SimpleSuggest
                        label={"Third party Country"}
                        service={services.fetchSearchCountry}
                        error={errors.header_ThirdPartyCountryName}
                        disabled={readonly.header_Quantity}
                        value={header.ThirdPartyCountryName}
                        onChange={({ id, name }) => {
                          onChangeHeader(dispatch, {
                            ThirdPartyCountryId: id,
                            ThirdPartyCountryName: name,
                          });
                        }}
                        style={{ whiteSpace: 'nowrap', width: '100%' }}
                      />
                      </Col>
                      </Row>
                    </React.Fragment>
                  ) : (
                    <Field
                      label={"Bank Account"}
                      error={errors.header_BankAccountName}
                      description={accountEmpty ? "First select an account" : null}
                    >
                      <Combobox
                        value={header.BankAccountItemId}
                        items={entities.accountBanks.map((a) => ({
                          id: a.BankAccountItemId,
                          description: `${a.BankAccountName} - ${a.BankAccountNumber}`,
                        }))}
                        disabled={accountEmpty || readonly.header_Quantity}
                        invalid={!!errors.header_BankAccountName}
                        onChange={(id) =>
                          onChangeHeader(
                            dispatch,
                            entities.accountBanks.find((a) => a.BankAccountItemId == id)
                          )
                        }
                        emptyLabel={"Bank Account"}
                      />
                    </Field>
                  )}
                </React.Fragment>
              )}

              {/* ##### Cheque ##### */}
              {header.TransferType === IOTransferType.Cheque && (
                <React.Fragment>
                  <SimpleSuggest
                    label={"Bank"}
                    service={services.fetchSearchCustodianEntity}
                    error={errors.header_BankAccountName}
                    disabled={readonly.simple_Quantity}
                    value={header.BankAccountName || ""}
                    onChange={({ id, name }) =>
                      onChangeHeader(dispatch, {
                        BankAccountId: id,
                        BankAccountName: name,
                      })
                    }
                  />
                  <Field label={"#Cheque"} error={errors.header_ChequeNumber}>
                    <Input
                      type={"text"}
                      placeholder={"Number"}
                      value={header.ChequeNumber || ""}
                      invalid={errors.header_ChequeNumber}
                      onChange={(e) =>
                        onChangeHeader(dispatch, {
                          ChequeNumber: e.target.value,
                        })
                      }
                      disabled={readonly.header_Quantity}
                    />
                  </Field>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {/* ##### Commission ###### */}
          <Row>
            <Col lg={6}>
              <Field label={"Commission"} error={errors.header_Commission}>
                <Numeric
                  value={header.Commission}
                  placeholder={`Commission`}
                  disabled={readonly.header_Commission}
                  onChange={(v) => onChangeHeader(dispatch, { Commission: v })}
                  invalid={!!errors.header_Commission}
                  {...commissionSuffix(null)}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.header_CommissionType}>
                <Combobox
                  value={header.CommissionType}
                  items={[
                    { id: "FaceValueCash", description: "$ Cash" },
                    { id: "PrincipalPercentage", description: "% Principal" },
                  ]}
                  disabled={readonly.header_CommissionType}
                  invalid={!!errors.header_CommissionType}
                  onChange={(v) => onChangeHeader(dispatch, { CommissionType: v })}
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={6}>
          <Files
            id={io.Id}
            ioType={io.IOType}
            readonly={readonly.Quantity}
            dispatch={dispatch}
            files={io.files}
            downloadFile={services.fetchDownloadIOFile}
          />
          {reasons.length > 0 && (
          <Field label={"Reason"} error={errors.ReasonId}>
            <Input
              tabIndex="3"
              type="select"
              placeholder={"Reason"}
              disabled={readonly.ReasonId}
              value={io.ReasonId}
              invalid={!!errors.ReasonId}
              onChange={(e) =>
              onChange(dispatch, { ReasonDescription: e.target.options[e.target.selectedIndex].text,
                                   ReasonId: +e.target.value })
              } >
              <option value="">Select a reason</option>
              {reasons.map((reason) => (
                <option  value={+reason.key}>
                  {reason.value}
                </option>
              ))}
            </Input>
          </Field>
        )}

        </Col>
      </Row>

      {!io.Local && (
        <React.Fragment>
          <Row>
            <Col lg={6} xs={12}>
              {/* ##### Account ###### */}
              <Field label={"#Account"} error={errors.header_BankAccountNumber}>
                <Input
                  type={"text"}
                  placeholder={"#Account"}
                  value={header.BankAccountNumber || ""}
                  invalid={!!errors.header_BankAccountNumber}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      BankAccountNumber: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                />
              </Field>

              {/* ##### Bank ###### */}
              <Field label={"Bank"} error={errors.header_BankAccountName}>
                <Input
                  type={"text"}
                  placeholder={"Bank"}
                  value={header.BankAccountName || ""}
                  invalid={!!errors.header_BankAccountName}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      BankAccountName: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                />
              </Field>

              {/* ##### Intermediary Bank ###### */}
              <Field label={"Intermediary Bank"} error={errors.header_IntermediaryBank}>
                <Input
                  type={"text"}
                  placeholder={"Intermediary Bank"}
                  value={header.IntermediaryBank || ""}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      IntermediaryBank: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_IntermediaryBank}
                />
              </Field>
            </Col>

            <Col lg={6} xs={12}>
              {/* ##### Country ###### */}
              <SimpleSuggest
                label={"Country"}
                service={services.fetchSearchCountry}
                error={errors.header_CountryName}
                disabled={readonly.header_Quantity}
                value={header.CountryName}
                onChange={({ id, name }) => {
                  onChangeHeader(dispatch, {
                    CountryId: id,
                    CountryName: name,
                  });
                }}
              />

              {/* ##### ABA/SWIFT ###### */}
              <Field label={"ABA/SWIFT"} error={errors.header_ABASWIFT}>
                <Input
                  type={"text"}
                  placeholder={"ABA/SWIFT"}
                  value={header.ABASWIFT || ""}
                  onChange={(e) => onChangeHeader(dispatch, { ABASWIFT: e.target.value })}
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_ABASWIFT}
                />
              </Field>

              {/* ##### Intermediary ABA/SWIFT ###### */}
              <Field label={"Intermediary ABA/SWIFT"} error={errors.header_IntermediaryABASwift}>
                <Input
                  type={"text"}
                  invalid={!!errors.header_IntermediaryABASwift}
                  placeholder={"Intermediary ABA/SWIFT"}
                  value={header.IntermediaryABASwift || ""}
                  onChange={(e) =>
                    onChangeHeader(dispatch, {
                      IntermediaryABASwift: e.target.value,
                    })
                  }
                  disabled={readonly.header_Quantity}
                />
              </Field>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Container>
  );
};

export default WithdrawalBulk;
